import { createWebappRoute, getRouter } from '../helpers';

export default [
  // 'book_demo': 'bookDemo',
  createWebappRoute({
    path: '/book_demo',
    name: 'book_demo-module',
    async component() {
      console.log('ROUTER, book_demo');

      try {
        await DP.BootstrapPromise.get('DPMasterDesktoploaded');
      } catch (e) {
        console.error(e);
      }

      getRouter().push({ name: 'home-module' });
      $dt.vwDesktopContent.toggleBookADemo('Intercom');

      return {};
    },
  }),
];
